import React from 'react'
import "./Contact.css";
import msg_icon from "../../assets/msg-icon.png";
import mail_icon from "../../assets/mail-icon.png";
import phone_icon from "../../assets/phone-icon.png";
import location_icon from "../../assets/location-icon.png";
import white_arrow from "../../assets/white-arrow.png";
export default function Contact() {
    const [result, setResult] = React.useState("");

    const onSubmit = async (event) => {
      event.preventDefault();
      setResult("Sending....");
      const formData = new FormData(event.target);
  
      formData.append("access_key", "637ce21e-506a-49df-b205-169f0663622");
  
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData
      });
  
      const data = await response.json();
  
      if (data.success) {
        setResult("Form Submitted Successfully");
        event.target.reset();
      } else {
        console.log("Error", data);
        setResult(data.message);
      }
    };
  
  return (
    <div>
        <h2 className='contact-name'>Contact Us</h2>
    <h1 className="contact-sub" >Get in Touch</h1>
   
    <div className="contact">
       <div className="contact-col">
        <h3>Send us a message<img src={ msg_icon} alt="" /></h3>
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio officiis 
            libero quibusdam qui illum. Similique repudiandae velit accusamus necessitatibus, 
            voluptate tenetur rem voluptatem illum labore ipsum harum delectus commodi in.</p>
            <ul>
                <li><img src={mail_icon} alt="" />Contact yashudagar08@gmail.com</li>
                <li><img src={phone_icon} alt="" />+91 1234567890</li>
                <li><img src={location_icon} alt="" />xyz street Dwarka</li>

            </ul>
        </div> 
       <div className="contact-col">
    <form onSubmit={onSubmit}>
        <label>Your Name</label>
        <input type="text" name="name" placeholder="Enter your name " required />
        <label>Phone Number</label>
        <input type="tel" name="phone" placeholder="Enter your phone number " required />
        <label>Write your message here</label>
       <textarea name="message"  rows="6" placeholder="Enter your message" required></textarea>
       <button type="submit" className="btn dark-btn">Submit now <img src={ white_arrow}alt="" /></button>
    </form>
    <span>{result}</span>
    </div> 
    </div>
    </div>
  )
}
